<br><br>

<div class="container-fluid w-5/6 p-md-5">
  <div class="row w-100 mx-0 justify-content-center mt-5">
    <div class="col-12 col-md-7 col-lg-8 my-auto px-md-5  py-5 mt-3 py-md-0 mb-4 order-1">
      <div class="title">
        {{ "LinkedIn Ranking" | translate }}
      </div>
      <div class="description">
        {{
        "Optimize your LinkedIn. Get Reach to right people, New opportunities."
        | translate
        }}
      </div>
      <button class="gradient-button" (click)="scrollToSteps()">
        {{ "Scan your LinkedIn" | translate }}
      </button>
    </div>
    <img class="col-8 col-md-5 col-lg-4 text-center p-0 order-2 mt-5" src="assets/img/optimize-linkedIn.png" />
  </div>
<app-video-tutorial
  [title]="'linkedIn.videoTitle'"
  [buttonText]="'linkedIn.videoButton'"
 (buttonClicked)="scrollToSteps()"
  [videoPath]="'assets/video/Linkedin.mp4'"
  [videoPoster]="'assets/img/optimize-linkedIn.png'"
  [features]="[
    'linkedIn.feature1',
    'linkedIn.feature2',
    'linkedIn.feature3'
  ]">
</app-video-tutorial>
  <div class="scan mt-5" #stepsSection>{{ "Scan Now" | translate }}</div>

  <div class="my-4">
    <p-steps [model]="steps" [(activeIndex)]="activeIndex" />
  </div>

  <!-- Step 1: Upload LinkedIn PDF -->
  <div class="row w-100 m-0" *ngIf="activeIndex === 0" (dragover)="onDragOver($event)" (drop)="onLinkedinDrop($event)">
    <div class="col-lg-8 col-sm-7 col-12 p-0">
      <div class="upload-resume">
        <img width="15%" src="../../../assets/img/upload linkedin.png" />
        <h3>{{ "Upload your Public LinkedIn Profile in PDF" | translate }}</h3>
        <p>{{ "Drag and drop your resume as PDF or word file" | translate }}</p>
        <p>{{ "Or" | translate }}</p>
        <input type="file" id="uploadLinkedin" (change)="onLinkedinSelected($event)" accept=".pdf,.doc,.docx"
          #uploadLLinked hidden />
        <button class="button" (click)="uploadLLinked.click()">
          {{ "Select from Browser" | translate }}
        </button>
      </div>
    </div>
    <div class="col-lg-4 col-sm-5 col-12 p-5 p-sm-3 steps">
      <p>1. {{ "Go to your public LinkedIn profile" | translate }}</p>
      <p>
        2.
        {{ "linkedin_save_to_pdf_hint" | translate }}
      </p>
      <p>
        3.
        {{ "Upload it below and our AI will analyze it instantly." | translate }}
      </p>
      <img width="90%" src="../../../assets/img/upload linkedin steps.png" />
    </div>
  </div>
  <div class="job-form my-2" *ngIf="activeIndex === 1">
    <div class="form-container">
      <div class="form-group">
        <label>{{ 'Job Title' | translate }}</label>
        <input type="text" [(ngModel)]="jobTitle" placeholder="{{ 'Enter your job title' | translate }}"
          class="form-input" />
      </div>
      <div class="form-group">
        <label>{{ 'Objective' | translate }}</label>
        <textarea [(ngModel)]="objective" placeholder="{{ 'Enter your objective' | translate }}" class="form-textarea"
          rows="4"></textarea>
      </div>
      <div class="form-btn-container">
        <button class="button next-btn" (click)="nextStep()">
          {{ 'Next' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="m-5"></div>
</div>

<section class="cv-section">
  <div class="container">
    <div class="text-center">
      <h3 class="titlle">{{ 'linkedInScan.title' | translate }}</h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-7 px-md-5">
        <ul class="custom-list">
          <li>{{ 'linkedInScan.point1' | translate }}</li>
          <li>{{ 'linkedInScan.point2' | translate }}</li>
          <li>{{ 'linkedInScan.point3' | translate }}</li>
        </ul>
      </div>
      <div class="col-12 col-md-5 mb-4 mb-md-0 text-center">
        <img class="img-fluid" src="assets/img/Frame_2095587930-removebg-preview.png" alt="CV Image" />
      </div>
    </div>
  </div>
</section>

<section class="cv-section">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="titlle">{{ 'cv.title' | translate }}</h2>
      <p class="subtitle mt-3">{{ 'cv.subtitle' | translate }}</p>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-5 mb-4 mb-md-0 text-center">
        <img class="img-fluid" src="../../../assets/img/1014216_OJ8XXE1.png" alt="CV Image" />
      </div>
      <div class="col-12 col-md-7 px-md-5">
        <p class="title-bulid">{{ 'cv.buildTitle' | translate }}</p>
        <p class="section-text">{{ 'cv.buildDescription' | translate }}</p>
        <button class="gradient-button" routerLink="/generatResume">
          {{ 'cv.buildButton' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>